import React, { ReactNode } from 'react';
import { MarketIndicatorOutlook } from '../../../../Generated/Raven-Demeter';
import { IWithPageElementProps } from '../../../Pages/DashboardCustomization/DashboardCustomizationDefinitions';
import { TrackingEvent } from '../../../Services/Tracking/TrackingService';
import ChartWrapper from '../ChartWrapper/ChartWrapper';
import ImageChartRaw from './ImageChartRaw';

export interface IImageChartProps extends IWithPageElementProps {
    imageSource: string;
    title?: string;
    subtitle?: string;
    marketIndicatorOutlook?: MarketIndicatorOutlook;
    dataSourceTag?: string;
    isLoading?: boolean;
    isCsvDownloadAvailable?: boolean;
    isXlsxDownloadAvailable?: boolean;
    testId?: string;
    footer?: ReactNode;
    showPopout?: boolean;
    showOnlyAsPopout?: boolean;
    setShowPopout?: (showPopout: boolean) => void;
    track: TrackingEvent;
}

const ImageChart: React.FC<IImageChartProps> = (props: IImageChartProps) => (
    <ChartWrapper
        name="ImageChart"
        title={props.title}
        customTitle={props.customTitle}
        subtitle={props.subtitle}
        dataSourceTag={props.dataSourceTag ?? ''}
        isLoading={props.isLoading ?? false}
        footer={props.footer}
        showPopout={props.showPopout}
        setShowPopout={props.setShowPopout}
        maxWidthHeightRatio={props.maxWidthHeightRatio}
        marketIndicatorOutlook={props.marketIndicatorOutlook}
        headerOptions={{
            isCsvDownloadAvailable: props.isCsvDownloadAvailable ?? false,
            isXlsxDownloadAvailable: props.isXlsxDownloadAvailable ?? false,
            showOnlyAsPopout: props.showOnlyAsPopout,
            isInDashboardEditMode: props.isInDashboardEditMode,
            maximizeMinimizeButton: props.maximizeMinimizeButton,
            handleMoreOptionsSelection: props.handleMoreOptionsSelection,
        }}
        testId={props.testId}
        dragIndicatorIcon={props.dragIndicatorIcon}
        track={props.track}
    >
        <ImageChartRaw imageSource={props.imageSource} />
    </ChartWrapper>
);

export default ImageChart;
